import { Div } from "../../../../../base/components/native/div";
import { TArticle } from "../../../../../types/article";
import { TFAQ } from "../../../../../types/faq";
import { baseStyle } from "./faq-item.style";

export const FAQItem = (faq: TFAQ) => {

    const base = Div(faq.q)
    base.el.setAttribute('data-id', faq.key)
    base.cssClass(baseStyle)
    base.el.onclick = () => {
        base.emit('select', faq)
    }

    return Object.assign(base, {
        getKey: () => faq.key,
        update: ({ q, a }: TFAQ) => {
            base.el.innerHTML = q
            faq.q = q
            faq.a = a
        },
        getValue: () => {
            return {
                key: faq.key,
                q: faq.q.replace(/<\/?p>?/gm, ''),
                a: faq.a.replace(/<\/?p>?/gm, ''),
            }
        }
    })
}